import { AllFeatureIds } from 'generated/featureIds.generated'

export enum AtsAppTypeIds {
  AtsWhatsapp = 'ats_whatsapp',
  LinkedinLimitedListings = 'linkedin_limited_listings',
  AtsIdealDiscIntegration = 'ats_ideal_disc_integration',
}

export enum AtsIntegrationTypeIds {
  Indeed = 'indeed',
  Join = 'join',
  WelcomeToTheJungle = 'welcome_to_the_jungle',
  Infojobs = 'infojobs',
}

export interface IntegrationData {
  [key: string]: {
    id: AtsAppTypeIds | AtsIntegrationTypeIds
    title: string
    description: string
    image: {
      src: string
      alt: string
    }
    feature?: AllFeatureIds
  }
}

export interface MarketplaceIntegrationData {
  name: string
  marketplaceId: string
  imageUrl: string
  description: string
  enabled: boolean
}
